import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Subject, takeUntil } from 'rxjs';
import { VERIFY_OTP, REQUEST_OTP_EMAIL } from 'src/app/constants/endpoint.const';
import { PinModel } from 'src/app/models/pin.model';
import { BaseService } from 'src/app/services/base.service';
import { TriggerService } from 'src/app/services/trigger.service';
import * as moment from 'moment';

@Component({
  selector: 'app-modal-verif-otp',
  standalone: false,
  templateUrl: './modal-verif-otp.component.html',
  styleUrl: './modal-verif-otp.component.scss',
})
export class ModalVerifOtpComponent {
  @Input() isOpen: boolean = false;
  @Output() close = new EventEmitter<void>();
  pin!: PinModel;
  settings = {
    length: 6,
    numbersOnly: true,
  };
  @Input() otpParams = {
    pin: '',
  };
  otp: string = '';
  isErrorMessage: boolean = false;
  destroy$ = new Subject();
  isDisabled: boolean = true;

  minutes: number = 0;
  seconds: number = 0;
  isLimit: boolean = false;
  emailTeam: string = localStorage.getItem('email-user') || '';
  @Input() token: string = '';

  @Input() nextRequestAt: string = '';
  @Input() remainingTime: number = 60;
  intervalId: any;
  resendToken: string = ''

  constructor(
    private baseService: BaseService,
    private message: NzMessageService,
    private triggerService: TriggerService
  ) {}

  sendOTP() {
    this.isOpen = false;
    this.close.emit();
  }

  onChange(e: string) {
    this.otp = e;
    if (e.length === 6) {
      this.isDisabled = false;
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.code === 'Backspace') {
      this.isErrorMessage = false;
      this.isDisabled = true;
    }
  }

  handleConfirm() {
    const params = {
      token: !this.resendToken ? btoa(this.token + '%team') : this.resendToken,
      otp: this.otp,
    };
    this.baseService
      .postData(VERIFY_OTP, params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.message.success('OTP Verified');
          this.triggerService.triggerParent$.next();
          this.isOpen = false;
        },
        (err) => {
          this.message.error(err.error.meta.message);
        }
      );
  }

  resendVerif() {
    const params = {
      purpose: 'team',
      type_otp: 'email',
      token: this.token,
    };

    this.baseService
      .postData(REQUEST_OTP_EMAIL, params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.resendToken = btoa(res.data.token + '%team');
          const nextRequestTime = moment(res.data.next_request_at);
          const currentTime = moment();

          this.remainingTime = nextRequestTime.diff(currentTime, 'seconds');

          this.startCountdown();
        },
        (err) => {
          if (err.error.meta.message === 'reached limit request otp') {
            this.isLimit = true;
            this.message.create(
              'error',
              "Well, it looks like you're having trouble verifying your OTP, please contact us via live chat."
            );
          } else if (err.error.meta.message === 'otp not valid') {
            this.message.create(
              'error',
              "Incorrect OTP code, let's check again"
            );
          } else {
            this.message.create(
              'error',
              'Failed to request OTP, please try again'
            );
          }
        }
      );
  }

  startCountdown(): void {
    this.intervalId = setInterval(() => {
      if (this.remainingTime > 0) {
        this.remainingTime--;
        this.minutes = Math.floor(this.remainingTime / 60);
        this.seconds = this.remainingTime % 60;
      } else {
        clearInterval(this.intervalId);
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    this.destroy$.complete();
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
